import type {Transition} from "history"
import History from "../../index"

let historyUnblock: (() => void) | null = null

const blockNavigationAction = (msg: string, component: any) => ({
  type: "BLOCK_NAVIGATION_BLOCK" as const,
  msg,
  component
})

export const blockNavigation = (msg: string, component: any) => (dispatch) => {
  historyUnblock?.()
  historyUnblock = History.block((tx: Transition) => {
    dispatch(triggerBlockConfirmation(tx.retry))
  })
  dispatch(blockNavigationAction(msg, component))
}

export const unblockNavigation =
  (shouldUnblock = true) =>
  (dispatch, getState) => {
    const {unblocker} = getState().blockNavigation

    if (shouldUnblock) {
      // Deregister blocker first so tx.retry() doesn't trigger it again
      historyUnblock?.()
      historyUnblock = null
      dispatch({type: "BLOCK_NAVIGATION_UNBLOCK"})
      if (unblocker) {
        unblocker()
      }
    } else {
      // User chose to stay — hide modal but keep blocker active for future navigation
      dispatch({type: "BLOCK_NAVIGATION_HIDE"})
    }
  }

export const triggerBlockConfirmation = (unblocker: () => void) => ({
  type: "BLOCK_NAVIGATION_TRIGGER_CONFIRM" as const,
  unblocker
})

export const updateComponent = (component: any) => ({
  type: "BLOCK_NAVIGATION_UPDATE_COMPONENT" as const,
  component
})

export default {
  block: blockNavigation,
  unblock: unblockNavigation,
  trigger: triggerBlockConfirmation,
  update: updateComponent
}
